// The correlation id that ties one RUN of the wizard together: its client events and
// its /api/ai-lessons/ requests carry the same id, so the backend can join "the teacher
// reached the review step" to "the generation cost $0.004" to "the lesson was published".
//
// A module-level singleton, deliberately not Vuex:
//  * api_helper.js has to read it on every request. This module imports nothing but
//    `uuid`, so it is a leaf and can never close an import cycle with api_helper (which
//    every api/*.js pulls in).
//  * Nothing renders it, so reactivity buys nothing.
//  * It is session-scoped by construction — same property the aiLesson store module gets
//    by being absent from the persistedstate `paths` allowlist.
//
// Note the name: the wizard screen already has an unrelated `wizardRun` counter (it
// invalidates in-flight extract calls across a reset). This is `wizardRunId` everywhere.
import { v4 as uuidv4 } from 'uuid';

let currentRunId = '';

// Starts a new run. Called on mount and on every wizard reset, BEFORE the run's first
// event or request, so nothing is ever attributed to the previous run.
export function newWizardRunId() {
  try {
    currentRunId = uuidv4();
  } catch (e) {
    // A uuid failure must not be the reason a wizard run cannot start. The backend only
    // requires a UUID shape for the header, so a fallback id simply goes unheaded — the
    // client events still correlate among themselves.
    currentRunId = '';
  }
  return currentRunId;
}

export function getWizardRunId() {
  return currentRunId;
}

export function clearWizardRunId() {
  currentRunId = '';
}



// WEBPACK FOOTER //
// ./src/components/modules/aiLesson/wizardRunId.js